import React, {useState, useEffect} from 'react';
import { Grid, Collapse, Button } from '@mui/material';

import { connect } from "react-redux";
import { mapStateToProps } from "../../redux/reducers";
import PropTypes from "prop-types";

import BellIcon from '../../assets/images/bell-icon.svg';
import AlertSeperator from '../../assets/images/alert-seperater-line.svg';
import '../../styles/yellowBanner.scss';
import { getBanner } from '../../redux/actionTypes/banner';

let selectedLanguage = localStorage.getItem("selectedLanguage") 

if (selectedLanguage === null) {
  selectedLanguage = "en";
} else {
  selectedLanguage = selectedLanguage?.split("-")?.[0];
}

const YellowBanner = (props) => {
  const [language, setLanguage] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [isEnableAlert, setIsEnableAlert] = useState(false);
  const [yellowBanner, setYellowBanner] = useState([]);
  const [yellowBannerTwo, setYellowBannerTwo] = useState([]);
  const [yellowBannerThree, setYellowBannerThree] = useState([]);

  useEffect(()=>{
   props.getBanner();
  },[]);

  const handleAlert = () => {
    setShowAlert((prev) => !prev)
  }

  useEffect(()=>{ 
    if (props?.banner && props?.banner?.banner?.length > 0) {
      setIsEnableAlert(true);
      const data = props?.banner?.banner;
      const selectedLangBanner = data.filter(item=>item?.languageCdCodeK == selectedLanguage);
      const descriptions = selectedLangBanner.map(item => item?.dsc);
      setYellowBanner(descriptions); 
    }
  },[props.banner, selectedLanguage]);

  useEffect(() => { 
    setLanguage(props.language)
  }, [props.language])

    useEffect(()=>{
    const bannerDataTwo = [
      {"id":1,"code":"YELLOW","dsc":"Your EBT card will not work for food or cash benefits from 11 p.m. on Saturday, April 26, until mid-day on Sunday, April 27, because of system maintenance. You do not need to do anything. DTA will post an update when you can use your card again on <a href='https://mass.gov/EBT' target='_self'>https://mass.gov/EBT</a>.","language":"en"},
      {"id":2,"code":"YELLOW","dsc": "Debido al mantenimiento del sistema, no podrá utilizar su tarjeta EBT para acceder a los beneficios para alimentos o dinero en efectivo desde las 11 p.m. del sábado 26 de abril hasta el mediodía del domingo 27 de abril. El DTA publicará actualizaciones cuando empiece y cuando termine el mantenimiento en su sitio web, <a href='https://mass.gov/EBT' target='_self'>https://mass.gov/EBT</a>. Su tarjeta EBT seguirá funcionando después de la transición. No es necesario reemplazarla, y no tiene que hacer nada.","language":"es"},
      {"id":3,"code":"YELLOW","dsc":"Devido à manutenção do sistema, você não poderá usar seu cartão EBT para acessar benefícios alimentícios ou em dinheiro das 23h de sábado, 26 de abril, até o meio-dia de domingo, 27 de abril. O DTA publicará atualizações sobre o início e o término da manutenção no site <a href='https://mass.gov/EBT' target='_self'>https://mass.gov/EBT</a>. Seu cartão EBT continuará funcionando após a transição. Não é necessário substituí-lo, e você não precisa tomar nenhuma medida a respeito.","language":"pt"},
      {"id":4,"code":"YELLOW","dsc":"由于系统维护，从 4 月 26 日星期六晚上 11 点到 4 月 27 日星期日中午，您将无法使用 EBT 卡获取食品或现金补助。DTA 将在其网站 <a href='https://mass.gov/EBT' target='_self'>https://mass.gov/EBT</a>  上发布维护开始和结束的最新信息。维护完成后, EBT 卡仍可使用。您无需换卡和执行任何操作。","language":"zh"},
      {"id":5,"code":"YELLOW","dsc":"Do bảo trì hệ thống, bạn sẽ không thể sử dụng thẻ EBT để truy cập vào các khoản trợ cấp thực phẩm hoặc tiền mặt từ 11 giờ tối Thứ Bảy, ngày 26 tháng 4 cho đến giữa trưa Chủ Nhật, ngày 27 tháng 4. DTA sẽ đăng thông tin cập nhật khi quá trình bảo trì bắt đầu và khi kết thúc trên trang web <a href='https://mass.gov/EBT' target='_self'>https://mass.gov/EBT</a>. Thẻ EBT của bạn vẫn sẽ hoạt động sau khi chuyển đổi. Thẻ không cần phải thay đổi và bạn không cần phải làm gì cả.","language":"vi"}
    ];

    if (bannerDataTwo && bannerDataTwo.length) {
      const selectedLangBannerTwo = bannerDataTwo.find(item=>item.language == selectedLanguage);

      setYellowBannerTwo(selectedLangBannerTwo.dsc);
      setIsEnableAlert(true);
    }
  },[]);
  const banners =  yellowBanner;
    return (
      <>
      { isEnableAlert && (<>
        <Grid container display={{md: 'block' }} className="yellow-wrapper">
          <Grid container maxWidth="lg" className="yellow-wrapper-banner">
            <Grid item xs={12} sx={{ mx: 2 }} display={{ md: 'block' }} className="banner div-center" >
              <Grid item xs={12} sx={{ mx: 2}} display="flex" alignItems="center" className="alerts-outer">
                <Grid item xs={12} sm={9} lg={9} md={9} className="div-center alerts-inner" display="flex" justifyContent="flex-start"
                  alignItems="center"
                  fontSize={{ xs: '14px', lg: '24px', md: '24px' }}>
                  <img src={BellIcon} alt="alert bell" height="27" width="30" style={{ marginTop: 5, marginRight: 10 }} />
                  <span className="ml-08 alert-fnt alert-txt">{language?.alerts}</span>
                  {/* <img className="ml-08 mr-08 alert-separator" src={AlertSeperator} alt="Separator line" height="25" /> */}
                  {/* <p className="ml-08 alert-fnt alert-update">{language?.alertHeading}</p> */}
                </Grid>
                <Grid item xs={12} sm={3} lg={3} md={3} display="flex" justifyContent="flex-end"  className="margib-btn alert-btn">
                  <Button className="alert-black-button" onClick={handleAlert} style={{ textTransform:'capitalize'}}
                  sx={{
                    '&:focus-visible': {
                            outline: '2px solid white',   
                            outlineOffset: '2px',
                            boxShadow: '0 0 0 4px black', 
                    }
                  }}>
                    {showAlert ? language?.hideAlerts : language?.showAlerts}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Collapse in={showAlert} aria-expanded={showAlert ? 'true' : 'false'} aria-controls='yellow_banner-content' sx={{ background: '#fef9e8' }} id="yellowBanner" classes={{ wrapper: 'alignCenter' }}>
          <Grid container maxWidth="lg" className="wrapper-banner" sx={{ display: showAlert ? 'block' : 'none'}} component={'div'} aria-labelledby='yellow_banner-button' role='region'>
            <Grid item xs={12} sx={{ mx: 2 }}  className="banner div-center">
              <Grid item xs={12} sx={{ mx: 2 }} display="flex" alignItems="center" className="alerts-outer">
                <Grid  item xs={12} sm={12} lg={12} md={12} className="div-center alerts-inner" display="flex" justifyContent="flex-start"
                  alignItems="center" fontSize={{ xs: '14px', lg: '24px', md: '24px' }} >
                  <Grid className="banner-txt" item xs={12} lg={12} md={12}  textAlign="justify" color={'#555555'} >
                    {/* {yellowBanner.map((banner, index) => banner ? (
                      <p key={index} dangerouslySetInnerHTML={{ __html: banner }} 
                      style={{ borderBottom: index !== yellowBanner.length - 1 ? '1px solid rgb(223, 191, 85)' : 'none', paddingBottom: '10px' }} 
                      />
                    ): null)} */}
                    {banners.map((banner, index) => banner ? (
                      <p className='bannerDesc' key={index} dangerouslySetInnerHTML={{ __html: banner }} 
                      style={{ borderBottom: index !== banners.length - 1 ? '1px solid rgb(223, 191, 85)' : 'none', paddingBottom: '10px' }} 
                      />
                    ): null)}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Collapse>
        </>
      )}
      </>
    )
}

const mapDispatchToProps = (dispatch) => {
  return {
    getBanner: (payload) => dispatch(getBanner(payload)),
  }
}

YellowBanner.propTypes = {
  language: PropTypes.object,
  data: PropTypes.object,
  isEnableAlert: PropTypes.bool,
  getBanner: PropTypes.func,
  banner: PropTypes.object
};

export default connect(mapStateToProps, mapDispatchToProps)(YellowBanner);